type SessionControlAction = "pause" | "resume" | "park" | "restore";
export function sessionControlOrigin(appUrl: string | null): string | null {
  if (!appUrl) return null;
  try {
    return new URL(appUrl).origin;
  } catch {
    return null;
  }
}

export function postSessionControl(
  frameWindow: Window,
  targetOrigin: string,
  action: SessionControlAction,
  scope?: "surface",
): string {
  const requestId = `continuation-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`;
  frameWindow.postMessage(
    {
      type: "ato.session-control.v1",
      action,
      ...(scope ? { scope } : {}),
      request_id: requestId,
    },
    targetOrigin,
  );
  return requestId;
}

